import {calcUserScore} from 'helpers/common-helper';
import {getDefaultExposure} from 'helpers/player-helper';
import BasePlayer from 'services/sports/default/base-player';
import {PlayersPoolBuilder} from 'services/players-pool/players-pool-builder';
import Action from 'actions';
import Const from 'constants';
import {getPlayerProjOwnFunctionality} from 'helpers/projected-ownership';
import {toFloat} from "helpers/number-helper";

export default class Player extends BasePlayer {
    createPoolsOfPlayers({incomingValues: {players}}) {
        const {playersLock} = Action.getState();

        let builder = new PlayersPoolBuilder(players);

        builder.addTaskOnScenario('doublePosition');
        builder.addTaskOnScenario('position');
        builder.addTaskOnScenario('playerId');
        builder.addTaskOnScenario('teamAndPosition');
        builder.addTaskOnScenario('allowedPositions');
        builder.addTaskOnProperty('gameInfo');
        builder.addTaskOnProperty('team');
        builder.addTaskOnProperty('positionName');
        builder.addTaskOnProperty('exposureMin', function (player) {
            return !playersLock.isLockedAnywhere(player.getId()) && player.exposureMin > 0;
        });
        builder.addTaskOnProperty('exposureMax', function (player) {
            return !playersLock.isLockedAnywhere(player.getId()) && player.exposureMax < 100;
        });

        return builder.execTasks();
    }

    getExpandedEntityParams({incomingValues = {}}) {
        const {userPointsType = 'adminPoints'} = incomingValues;
        const expandedPlayer = super.getExpandedEntityParams({incomingValues});
        const userPoints = parseFloat(expandedPlayer[userPointsType]);

        return {
            ...expandedPlayer,
            grades: parseFloat(expandedPlayer.grades),
            dvp: parseFloat(expandedPlayer.dvp),
            pra: toFloat(expandedPlayer.pra, 3),
            expected_minutes: parseInt(expandedPlayer.expected_minutes),
            points_per_minute: parseFloat(expandedPlayer.points_per_minute),
            userPoints: userPoints,
            userScore: calcUserScore(userPoints, expandedPlayer.salary, this.userScoreMultiplier),
            projOwn: {...getPlayerProjOwnFunctionality(expandedPlayer)},
            resetExposure() {
                this.exposureMin = getDefaultExposure('min');
                this.exposureMax = getDefaultExposure('max');
                this.captain_exposureMin = getDefaultExposure('min');
                this.captain_exposureMax = getDefaultExposure('max');
            },
        };
    }

    getPlayerById({incomingValues: {id}}) {
        const state = Action.getState();
        const {preparedPlayers} = state.playersData;
        const players = preparedPlayers.groupedBy.playerId();

        const [playerId, positionKey] = id.split(Const.LP_ITEM_DELIMITER);

        const player = {...players[playerId]};

        player.position = positionKey ? Number(positionKey) : Number(player.position[0]);

        return player;
    }
}
